var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"purse-body"},[_c('input',{attrs:{"type":"file"},on:{"change":_vm.onFileChange}}),_c('img',{attrs:{"src":_vm.imgSrc,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }